<template>
  <div class="bg_box "
       v-loading="firstLoading"
       element-loading-text="拼命加载中"
       element-loading-spinner="el-icon-loading"
       element-loading-background="rgba(0, 0, 0, 0.8)">

    <!--顶部banner-->
    <Banner
        bannerTitle="实时数据汇总"
        :form.sync="form" :send-message="sendMessage"
        :type="2"
        :rightBoxType="1"
    />

    <div class="dashboard-container ">

      <div class="left_box">
        <!--今日销售数据-->
        <Salesdata :name="get_time()" :salesdata="detail.sales_block" :gmvBlock="detail.gmv_block"/>
        <!--分销者数据-->
        <Sales :datas="detail.fx_user_detail_block"/>
      </div>

      <div class="right_box">
        <!--红榜-->
        <DistributorRed :datas="detail.fx_user_black_sales_block"/>
        <!--黑榜-->
        <DistributorBlack :datas="detail.fx_user_red_sales_block"/>
        <!--小组排行-->
        <GroupRank :datas="detail.fx_user_group_rank_block"/>
      </div>

    </div>
  </div>

</template>

<script>
import Socket from '@/utils/websocket'
import Salesdata from './components/bgcComponents/nowSalesdata.vue'
import Sales from './components/bgcComponents/nowSales.vue'
import DistributorRed from './components/bgcComponents/nowDistributorRed.vue'
import DistributorBlack from './components/bgcComponents/nowDistributorBlack.vue'
import GroupRank from './components/bgcComponents/nowGroupRank.vue'
import Banner from './components/banner.vue'

export default {
  name: 'BgcOne',
  components: {
    Salesdata,
    Sales,
    DistributorBlack,
    DistributorRed,
    GroupRank,
    Banner,
  },
  data() {
    return {

      firstLoading: false,

      socket: null,
      messages: [],
      error: null,
      wsUrl: ``,

      // wsUrl: 'wss://mp-dev.bobiton.com:9503/wsDataScreen/ws',

      form: {
        module: 7, // 模块 1兵工场 2机构 3分销者 4产品 5单兵工场 6单机构 7分销者实时数据汇总
        platform: 1, // 平台 1快手 2视频号 3抖音
        date_type: 0, // 时间类型：0时间选择 1自定义时间
        date_value: 1, // 时间选择 1今日 2昨日 3本月 4上月（当时间类型为0时必传 为1的时候传0）
        date_start: '', // 开始时间（当时间类型为1时必传 为0的时候传''）
        date_end: '', // 结束时间（当时间类型为1时必传 为0的时候传''）
        position: 0, // 是否拿取分销者数据
        module_user_id: '',
      },
      detail: {
        gmv_block: {
          current_sum_pay_amount: 0,//当前筛选gmv
          current_count_order: 0,//当前筛选订单量
          previous_sum_pay_amount: 0,//上期gmv
          previous_desc: '--',//上期描述文字
          gmv_growth: 0,//同比增长
          all_sum_pay_amount: 0,//累计gmv
        }, // gmv中心块
        sales_block: {
          current_count_order: 0,
          current_settle_count_order: 0,
          current_sum_pay_amount: 0,
          current_settle_sum_pay_amount: 0,
          current_sum_service_amount: 0,
          current_settle_sum_service_amount: 0,
          current_send_sample_count: 0,
          current_distinct_talent_num: 0
        }, // 销售数据（左上）


        fx_user_group_rank_block: {},//小组排行
        fx_user_red_sales_block: [],//红榜
        fx_user_black_sales_block: [],//黑榜
        fx_user_detail_block: [],//分销者详情表
      },

    }
  },

  mounted() {
    this.form.module_user_id = this.$route.query.bgcId
    this.connectWebSocket()
  },
  methods: {
    get_time() {
      if (this.form.date_type === 0) {
        if (this.form.date_value === 1) {
          return '今日'
        } else if (this.form.date_value === 2) {
          return '昨日'
        } else if (this.form.date_value === 3) {
          return '本月'
        } else if (this.form.date_value === 4) {
          return '上月'
        } else {
          return `自定义时间`
        }
      } else {
        return ``
      }

    },
    // 连接WebSocket
    connectWebSocket() {
      if (this.socket) {
        this.socket.close();
      }

      this.socket = new Socket(
          this.wsUrl,
          this.handleMessage,
          this.handleError
      );

      // 添加连接成功回调
      this.socket.onOpen = () => {
      };

      this.socket.connect();
    },


    // 处理接收到的消息
    handleMessage(data) {
      if (data == 'pong') {
        return
      }

      if (data.data === '连接成功') {
        this.sendMessage(); // 确保连接成功后再发送
      } else if (data.code == 400) {
        this.firstLoading = false
        this.$message.error(data.message);
      } else {
        this.firstLoading = false
        // gmv中心块
        if (data.data.gmv_block) {
          this.detail.gmv_block = data.data.gmv_block
        }
        // 销售数据（左上）
        if (data.data.sales_block) {
          this.detail.sales_block = data.data.sales_block
        }
        // 小组排行（）
        if (data.data.fx_user_group_rank_block) {
          this.detail.fx_user_group_rank_block = data.data.fx_user_group_rank_block
        }
        // 红榜（）
        if (data.data.fx_user_red_sales_block) {
          this.detail.fx_user_red_sales_block = data.data.fx_user_red_sales_block
        }
        // 黑榜（）
        if (data.data.fx_user_black_sales_block) {
          this.detail.fx_user_black_sales_block = data.data.fx_user_black_sales_block
        }
        // 分销者详情表（）
        if (data.data.fx_user_detail_block) {
          this.detail.fx_user_detail_block = data.data.fx_user_detail_block.list
        }

      }
    },

    // 处理错误
    handleError(error) {
      this.error = error.message || 'WebSocket连接错误'
    },
    // 发送消息
    sendMessage() {
      if (this.socket) {
        this.firstLoading = true
        this.socket.send(this.form)
      } else {
        this.error = '请先连接WebSocket'
      }
    },

    // 关闭连接
    closeWebSocket() {
      if (this.socket) {
        this.socket.close()
        this.socket = null
      }
    }
  },

  // 组件销毁时关闭WebSocket
  beforeDestroy() {
    if (this.socket) {
      this.socket.close()
    }
  },
}
</script>

<style lang="scss" scoped>
.bg_box {
  height: 100vh;
  background-image: url(../../assets/iamge_bg.png);
  background-size: 100% 100vh;
}

.dashboard-container {
  display: flex;
  justify-content: space-evenly;
  gap: 20px;
  padding: 0 20px;

  .left_box {
    width: calc(70% - 20px);
    display: flex;
    flex-direction: column;
    gap: 20px;

  }

  .right_box {
    width:30%;
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
}


</style>